import { render, staticRenderFns } from "./diseaseTypeNewDetail.vue?vue&type=template&id=76331cc4"
import script from "./diseaseTypeNewDetail.vue?vue&type=script&lang=js"
export * from "./diseaseTypeNewDetail.vue?vue&type=script&lang=js"
import style0 from "./diseaseTypeNewDetail.vue?vue&type=style&index=0&id=76331cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports